module.exports = __webpack_public_path__ + "img/NewsCenterDetails5_pic2.64b81e27.png";